@if(component) {
<div class="wrap pos-relative overflow-hidden"
     [ngClass]="component.backgroundImageRatio || 'ratio-16-9'">
    <img class="fill"
         [image]="component.backgroundImage">
    <div class="pos-absolute top-0 left-0 right-0 bottom-0">
        <div class="w-12 flex flex-justify-center m-t-10 m-t-5m m-t-5-s">
            <p class="h1"
               *iCms="'topText' of component"></p>
        </div>
        <div class="w-12 m-t-5 flex flex-middle flex-column-m flex-column-s wrap-x wrap-l">
            <div class="c-2"
                 *ifSize="'XL'">

            </div>
            <div class="c-4 c-12-m c-12-s p-l-10-m p-l-10-s p-r-10-m p-r-10-s m-r-10 m-r-0-m m-r-0-s">
                <div class="w-12 pos-relative"
                     [ngClass]="component.leftImageRatio || 'ratio-5-6'">
                    <img class="fill"
                         [image]="component.leftImage">
                    <div class="pos-absolute bottom-0 left-0 right-0 p-a-5"
                         *ifSize="'XL'">
                        <href class="w-7"
                              [link]="component.shopCollectionLink">
                            <button class="button">{{'shop collection' | translate}}</button>
                        </href>
                    </div>
                </div>
            </div>
            <div class="c-4 c-12-m c-12-s flex flex-justify-center">
                <div class="w-12">
                    @if(component?.cards?.length){
                    <swiper [effect]="'cards'"
                            [cardsEffect]="{
                            slideShadows: false,
                            rotate: false,
                            perSlideOffset: 5,
                        }"
                            [autoplay]="{
                            delay: component.autoplayDelay || 4000,
                        }"
                            [loop]="component?.loop"
                            (swiper)="onSwiper($event)">
                        @for (card of component?.cards; track $index) {
                        @if(!card.productVariant || getCardProductData(card)){
                        <ng-template swiperSlide
                                     let-data>
                            <div class="pos-relative w-10 w-12-m w-12-s p-l-10-m p-l-10-s p-r-10-m p-r-10-s">
                                <div class="ratio-3-4 w-12 pos-relative">
                                    <img class="fill"
                                         [image]="getCardProductData(card)?.image || card.cardImage">
                                    <button class="_swiper-button pos-absolute z-3 left-0 top-50"
                                            type="button"
                                            [attr.aria-label]="'Previous slide' | translate"
                                            (click)="previousSlide()"
                                            [disabled]="isBeggining && !component?.loop">
                                        <i class="icon-chevron-left bg-col-w p-a-3 fill flex flex-justify-center flex-middle"
                                           aria-hidden="true"></i>
                                    </button>
                                    <button class="_swiper-button pos-absolute z-3 right-0 m-r-6 top-50"
                                            type="button"
                                            [attr.aria-label]="'Next slide' | translate"
                                            (click)="nextSlide()"
                                            [disabled]="isEnd && !component?.loop">
                                        <i class="icon-chevron-right bg-col-w p-a-3 fill flex flex-justify-center flex-middle"
                                           aria-hidden="true"></i>
                                    </button>
                                </div>
                                <div class="p-a-2 p-b-4 bg-col-w _swiper-button">
                                    <p class="h4">{{getCardProductData(card)?.name || card.cardTitle}}</p>
                                    <href [link]="getCardProductData(card)?.url || card.ctaLink">
                                        <button [inlineButton]
                                                class="m-t-1">{{(card.productVariant ? ('shop now' | translate) :
                                            card.cta)| translate}}</button>
                                    </href>
                                </div>
                            </div>
                        </ng-template>
                        }
                        }
                    </swiper>
                    }
                    <div class="w-12 p-l-10 p-r-10 m-t-5"
                         *ifSize="'MS'">
                        <href class="w-12"
                              [link]="component.shopCollectionLink">
                            <button class="w-12 button">{{'shop collection' | translate}}</button>
                        </href>
                    </div>
                </div>
            </div>
            <div class="c-2"></div>
        </div>
    </div>
</div>
}